import React from 'react';
import { useEffect, useState } from 'react';
import { MdClose } from 'react-icons/md';
import * as jobsActions from '../../Redux/Actions/jobs';
import { FiDownload } from 'react-icons/fi';
import { downloadFile } from '../../utils/index';
import Loader from "react-loader-spinner";

const AdditionalPaymentDocumentModal = ({ t, showModal, handleClose, additionalPaymentAttachment }) => {

    const [fileArr, setFileArr] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        const attachmentId = additionalPaymentAttachment.map(({ attachment }) => attachment);
        jobsActions.getMetaDataPaymentReceipt(attachmentId).then(res => {
            setFileArr(res?.data);
            setLoading(false);
        }).catch((err) => {
            console.log(err);
            setLoading(false);
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [additionalPaymentAttachment]);

    const handleDownloadDocument = (id) => {
        jobsActions.downloadPaymentReceipt(id).then(res => {
            res && downloadFile(res);
        }).catch((err) => {
            console.log('Something Went Wrong', err);
        });
    }
   
    return (
        <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t("additionalPayments.additionalPaymentDocuments")}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleClose}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            { loading ? <Loader type="ThreeDots" color="#2d207d" height={40} width={40} style={{ textAlign: 'center' }} /> : 
                                <div className="mt-1 d-flex flex-wrap">
                                {(fileArr?.length === 0) ? <p className="text-muted text-center">{t("jobsManagement.noDataAvailable")}</p> : (fileArr?.map(({fileName, thumbnailUri, documentId}, index) => {
                                    const file = fileName.toLowerCase();
                                    let imgType = file && (file.includes('png') || file.includes('jpeg') || file.includes('jpg'));
                                    return (
                                        <div key={index} className="document font-weight-bold my-2 me-2">
                                            <div style={{ width: '-webkit-fill-available', height: '-webkit-fill-available', margin: '0 auto' }}>
                                                {imgType ? <img src={thumbnailUri} alt="Thumbnail" width="100%" height="100%" />
                                                    : <img src={'/Assets/nopreview_all.png'} alt="Thumbnail" style={{ width: '100%', height: '100%' }} />}
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between position-absolute bottom-0 bg-white p-2 " style={{ width: '100%' }}>
                                                <p className="m-0">{(fileName.length > 20) ? fileName.slice(0,19) + '..' : fileName}</p>
                                                <FiDownload onClick={() => handleDownloadDocument(documentId)} className="c-pointer" />
                                            </div>
                                        </div>
                                    )
                                }
                                ))}
                            </div>
                            }
                        </div>
                        <div className="modal-footer"></div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
}

export default AdditionalPaymentDocumentModal;
